
import store from '@/store';
import lang from './langTemplates/HelperClauses';
const clauses = lang.clauses;
const pref = store.state.lang;

export default [
  {
    form: 'login',
    title: '',
    blurb: '',
    dispatch: 'login',
    params: ['email', 'pw'],
    inputs: [
      {
        label: 'Email',
        optional: false,
        val: 'email',
        type: 'text'
      },
      {
        label: 'Password',
        optional: false,
        val: 'pw',
        type: 'password'
      }
    ],
    onSucceed: {
      util: 'dispatch',
      dest: 'getBundle'
    },
    onFail: {
      title: clauses.logFail[`${pref}Title`],
      data: clauses.logFail.jp
    },
    link: 'forgot'
  },

  {
    form: 'changeTemp',
    title: 'Enter New Password',
    blurb: '',
    dispatch: 'login',
    params: ['email', 'pw', 'newPassword'],
    inputs: [
      {
        label: 'New Password',
        optional: false,
        val: 'newPassword',
        type: 'password',
        match: true
      },
      {
        label: 'Confirm Password',
        optional: false,
        val: 'confirmPw',
        type: 'password',
        match: true
      }
    ],
    onSucceed: {
      util: 'dispatch',
      dest: 'getBundle'
    },
    onFail: {
      title: clauses.pwResetFail[`${pref}Title`],
      data: clauses.pwResetFail[pref]
    }
  },

  {
    form: 'forgot',
    title: 'Forgot Password',
    blurb: `NOTICE: Clicking "Confirm" below will clear your current password and a confirmation code will be sent to the email
    you have registered with Breezi-Pro. This can not be undone.`,
    dispatch: 'forceUpdate',
    params: ['forgotEmail'],
    inputs: [
      {
        label: 'Email',
        optional: false,
        val: 'forgotEmail',
        type: 'text'
      }
    ],
    onSucceed: {
      util: 'show',
      dest: 'forcePw'
    },
    onFail: {
      title: clauses.pwResetFail[`${pref}Title`],
      data: clauses.pwResetFail[pref]
    }
  },

  {
    form: 'forcePw',
    title: 'Confirm Password Change',
    blurb: '',
    dispatch: 'forceUpdate',
    params: ['forgotEmail', 'confPw', 'confCode'],
    inputs: [
      {
        label: 'Confirmation Code',
        optional: false,
        val: 'confCode',
        type: 'text'
      },
      {
        label: 'New Password',
        optional: false,
        val: 'confPw',
        type: 'password',
        match: true
      },
      {
        label: 'Confirm Password',
        optional: false,
        val: 'matchConfPw',
        type: 'password',
        match: true
      }
    ],
    onSucceed: {
      util: 'show',
      dest: 'login'
    },
    onFail: {
      title: clauses.pwResetFail[`${pref}Title`],
      data: clauses.pwResetFail[pref]
    }
  }

]



// WEBPACK FOOTER //
// ./src/lib/authTemplate.js